export default __webpack_public_path__ + "cb8d778bf7aca4d0f3d5a64a94d7a94f.webp";